const prevNextControlsTemplate = ({accessBtnPrevious, previousIndex, accessBtnNext, nextIndex}) => `<button type="button" name="Previous" class="ui disabled-button control-button tertiary-button previous-control" aria-disabled="false" title="${accessBtnPrevious}" tabindex="${previousIndex}">
   <span class="ui previous-button-glyph"></span>
</button>
<button type="button" name="Next" class="ui control-button tertiary-button next-control" aria-disabled="false" title="${accessBtnNext}" tabindex="${nextIndex}">
   <span class="ui next-button-glyph"></span>
</button>`;

export default prevNextControlsTemplate;
